"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Type = exports.ActivityFormStatus = void 0;

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/switch/style/css");

var _switch = _interopRequireDefault(require("antd/es/switch"));

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/steps/style/css");

var _steps = _interopRequireDefault(require("antd/es/steps"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _activities = require("../../redux/activities/activities.types");

var _ActivityBackgroundForm = _interopRequireDefault(require("./forms/ActivityBackgroundForm"));

var _ActivityDetailsForm = _interopRequireDefault(require("./forms/ActivityDetailsForm"));

var _ActivityQuestionForm = _interopRequireDefault(require("./forms/ActivityQuestionForm"));

var _ActivityReviewForm = _interopRequireDefault(require("./forms/ActivityReviewForm"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _util = require("../../service/util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import { OptionType } from 'antd/es/select';
const {
  Step
} = _steps.default;
const {
  confirm
} = _modal.default;
var ActivityFormStatus;
exports.ActivityFormStatus = ActivityFormStatus;

(function (ActivityFormStatus) {
  ActivityFormStatus["WAIT"] = "wait";
  ActivityFormStatus["PROCESS"] = "process";
  ActivityFormStatus["FINISH"] = "finish";
  ActivityFormStatus["ERROR"] = "error";
})(ActivityFormStatus || (exports.ActivityFormStatus = ActivityFormStatus = {}));

var Type;
exports.Type = Type;

(function (Type) {
  Type[Type["zero"] = 0] = "zero";
  Type[Type["quiz"] = 1] = "quiz";
  Type[Type["category"] = 2] = "category";
  Type[Type["category_no_answer"] = 3] = "category_no_answer";
  Type[Type["cyoa"] = 4] = "cyoa";
  Type[Type["fill_in_the_blank"] = 5] = "fill_in_the_blank";
  Type[Type["goals"] = 6] = "goals";
  Type[Type["ranking"] = 7] = "ranking";
  Type[Type["screener"] = 8] = "screener";
  Type[Type["question"] = 9] = "question";
})(Type || (exports.Type = Type = {}));

class ActivityFormContainer extends _react.Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      activity: {
        title: '',
        type: '',
        typeId: -1,
        category: '',
        description: '',
        prompt: '',
        intro: '',
        randomizeQuestions: false,
        isHealthAssessment: false,
        background: {
          gradient: {},
          filename: ''
        },
        publishDate: '',
        feedback: [],
        options: [],
        questions: [],
        tree: {
          questions: {},
          options: {}
        },
        upload: undefined
      },
      current: 0,
      statuses: [ActivityFormStatus.PROCESS, ActivityFormStatus.WAIT, ActivityFormStatus.WAIT, ActivityFormStatus.WAIT],
      visible: true,
      backgroundType: 'gradient',
      previewImage: '',
      image: undefined,
      creative: false,
      editable: false,
      loading: false
    };

    this.handleSave = e => {
      const {
        form
      } = this.state;

      if (form) {
        form.validateFields().then(() => {
          this.setStatus(ActivityFormStatus.FINISH);
          confirm({
            title: 'Are you sure you want to create this activity?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              this.handleSaveActivity();
            },

            onCancel() {}

          });
        }).catch(err => {
          this.setStatus(ActivityFormStatus.ERROR);
        });
      }
    };

    this.handlePublish = e => {
      const {
        form
      } = this.state;

      if (form) {
        form.validateFields().then(() => {
          this.setStatus(ActivityFormStatus.FINISH);
          confirm({
            title: 'Are you sure you want to create this activity?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              this.handleSaveAndPublishActivity();
            },

            onCancel() {}

          });
        }).catch(err => {
          this.setStatus(ActivityFormStatus.ERROR);
        });
      }
    };

    this.handleSaveActivity = async () => {
      const {
        closeHandler,
        upsertActivity
      } = this.props;
      const {
        activity,
        backgroundType,
        image
      } = this.state; // validate and save

      if (activity) {
        activity.intro = (0, _util.cleanstring)(activity.intro);
        activity.description = (0, _util.cleanstring)(activity.description);

        if (activity.background) {
          if (backgroundType === 'image') {
            activity.background.gradient = undefined;

            if (image) {
              activity.upload = image;
            }
          } else if (backgroundType === 'gradient') {
            activity.background.filename = undefined;
          }
        }

        if (activity.typeId === Type.cyoa && activity.tree) {
          /**
           * After saving, request gets sent over axios, which doesn't support
           * sending Maps over the request.body, so we stringify the Map entries
           * to parse once we receive them on the server
           */
          activity.tree = {
            questions: JSON.stringify([...activity.tree.questions]),
            options: JSON.stringify([...activity.tree.options])
          };
        }

        upsertActivity(activity);

        _message2.default.success('Activity created successfully!');
      }

      this.resetState();
      closeHandler();
    };

    this.handleSaveAndPublishActivity = async () => {
      const {
        closeHandler,
        upsertActivity
      } = this.props;
      const {
        activity,
        backgroundType,
        image
      } = this.state; // validate and save

      if (activity) {
        activity.intro = (0, _util.cleanstring)(activity.intro);
        activity.description = (0, _util.cleanstring)(activity.description);

        if (activity.background) {
          if (backgroundType === 'image') {
            activity.background.gradient = undefined;

            if (image) {
              activity.upload = image;
            }
          } else if (backgroundType === 'gradient') {
            activity.background.filename = undefined;
          }
        }

        if (!activity.publishDate) {
          activity.publishDate = (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss');
        }

        if (activity.typeId === Type.cyoa && activity.tree) {
          /**
           * After saving, request gets sent over axios, which doesn't support
           * sending Maps over the request.body, so we stringify the Map entries
           * to parse once we receive them on the server
           */
          activity.tree = {
            questions: JSON.stringify([...activity.tree.questions]),
            options: JSON.stringify([...activity.tree.options])
          };
        }

        upsertActivity(activity);

        _message2.default.success('Activity created successfully!');
      }

      this.resetState();
      closeHandler();
    };

    this.handleCancel = e => {
      const {
        closeHandler,
        creative
      } = this.props;
      const {
        editable
      } = this.state;

      if (creative || editable) {
        confirm({
          title: 'Are you sure you want to leave this activity?',
          content: 'You will lose all changes.',
          okText: 'Leave',
          okType: 'danger',
          onOk: () => {
            this.resetState();
            closeHandler();
          },

          onCancel() {}

        });
      } else {
        this.resetState();
        closeHandler();
      }
    };

    this.handleClose = e => {
      const {
        closeHandler
      } = this.props;
      closeHandler();
      this.resetState();
    };

    this.next = () => {
      const {
        current,
        form
      } = this.state;

      if (form) {
        form.validateFields().then(() => {
          this.setState({
            current: current + 1
          });
        });
      }
    };

    this.previous = () => {
      const current = this.state.current - 1;
      this.setState({
        current
      });
    };

    this.setStatus = status => {
      const {
        current,
        statuses
      } = this.state;
      const updated = [...statuses];
      updated[current] = status;
      this.setState({
        statuses: updated
      });
    };

    this.setBackgroundType = type => {
      const {
        previewImage,
        activity
      } = this.state;

      if (type === 'image' && previewImage.length === 0) {
        this.setStatus(ActivityFormStatus.PROCESS);
      } else if (type === 'gradient' && activity.background && !activity.background.gradient) {
        this.setStatus(ActivityFormStatus.PROCESS);
      }

      this.setState({
        backgroundType: type
      });
    };

    this.setPreviewImage = base64 => {
      if (base64) {
        this.setState({
          previewImage: base64
        }, () => {
          this.setStatus(ActivityFormStatus.FINISH);
        });
      }
    };

    this.uploadFile = file => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          if (reader.result) {
            this.setPreviewImage(reader.result);
            this.setStatus(ActivityFormStatus.FINISH);
            this.setState({
              image: file
            });
            resolve(true);
          }

          resolve(false);
        };
      });
    };

    this.removeFile = () => {
      this.setState({
        previewImage: '',
        image: undefined
      });
    };

    this.resetState = () => {
      const resetState = _.cloneDeep(this.defaultState);

      this.setState(resetState);
    };

    this.setActivity = props => {
      if (props) {
        const {
          activity
        } = this.state;

        _.assign(activity, props);

        this.setState({
          activity: _.cloneDeep(activity)
        });
      }
    };

    this.setActiveForm = form => {
      this.setState({
        form
      });
    };

    this.onEditChange = checked => {
      const {
        activity
      } = this.props;

      if (checked && (activity === null || activity === void 0 ? void 0 : activity.id) && (0, _moment.default)(activity.publishDate).isSameOrBefore()) {
        _message2.default.error('You cannot edit a published activity, if you need to update or fix a small detail or typo contact the OCS team.');
      } else {
        this.setState({
          editable: checked
        });
      }
    };

    this.renderTitle = () => {
      const {
        creative,
        editable
      } = this.state;
      let text;

      if (creative) {
        text = 'Create New Activity';
      } else if (editable) {
        text = 'Activity: Edit Mode';
      } else {
        text = 'Activity: View Mode';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-form-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "activity-title-text"
      }, text), !creative && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Click the switch to toggle view/edit mode."
      }, /*#__PURE__*/_react.default.createElement(_switch.default, {
        checked: editable,
        onChange: this.onEditChange
      })));
    };

    this.renderSteps = () => {
      const {
        backgroundType,
        activity,
        previewImage,
        image,
        creative,
        editable
      } = this.state;
      const {
        background
      } = activity;
      return [{
        title: 'Background',
        content: /*#__PURE__*/_react.default.createElement(_ActivityBackgroundForm.default, {
          creative: creative,
          editable: editable,
          background: background,
          backgroundType: backgroundType,
          setActivity: this.setActivity,
          uploadFile: this.uploadFile,
          removeFile: this.removeFile,
          setBackgroundType: this.setBackgroundType,
          image: image,
          previewImage: previewImage,
          setActiveForm: this.setActiveForm
        })
      }, {
        title: 'Details',
        content: /*#__PURE__*/_react.default.createElement(_ActivityDetailsForm.default, {
          creative: creative,
          editable: editable,
          activity: activity,
          setStatus: this.setStatus,
          setActivity: this.setActivity,
          setActiveForm: this.setActiveForm
        })
      }, {
        title: 'Questions',
        content: /*#__PURE__*/_react.default.createElement(_ActivityQuestionForm.default, {
          creative: creative,
          editable: editable,
          activity: activity,
          setActivity: this.setActivity,
          setActiveForm: this.setActiveForm
        })
      }, {
        title: 'Save',
        content: /*#__PURE__*/_react.default.createElement(_ActivityReviewForm.default, {
          creative: creative,
          editable: editable,
          activity: activity,
          setActivity: this.setActivity,
          setActiveForm: this.setActiveForm
        })
      }];
    };

    this.renderActions = length => {
      const {
        current,
        editable,
        creative
      } = this.state;
      const footerActions = [];

      if (current < length - 1) {
        footerActions.push( /*#__PURE__*/_react.default.createElement(_button.default, {
          key: "next",
          type: "primary",
          onClick: this.next
        }, "Next"));
      }

      if (current === length - 1) {
        if (creative || editable) {
          footerActions.push( /*#__PURE__*/_react.default.createElement(_button.default, {
            key: "save",
            type: "primary",
            onClick: this.handleSave
          }, "Save"));
          footerActions.push( /*#__PURE__*/_react.default.createElement(_button.default, {
            key: "saveAndPublish",
            type: "primary",
            onClick: this.handlePublish
          }, "Save & Publish"));
        } else {
          footerActions.push( /*#__PURE__*/_react.default.createElement(_button.default, {
            key: "close",
            type: "primary",
            onClick: this.handleClose
          }, "Close"));
        }
      }

      if (current > 0) {
        footerActions.push( /*#__PURE__*/_react.default.createElement(_button.default, {
          key: "previous",
          onClick: this.previous
        }, "Previous"));
      }

      return footerActions;
    };

    const {
      creative,
      activity,
      getActivityStatus
    } = this.props;

    const updatedState = _.cloneDeep({ ...this.defaultState,
      creative
    });

    if (!creative && activity) {
      const {
        categoryId
      } = activity;

      const mergedActivity = _.merge(updatedState.activity, activity);

      if (categoryId) {
        mergedActivity.category = categoryId;
      }

      this.state = { ...updatedState,
        activity: mergedActivity,
        loading: getActivityStatus.isLoading
      };
    } else {
      this.state = { ...updatedState
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.editable !== this.state.editable && !this.props.creative) {
      this.setStatus(ActivityFormStatus.FINISH);
    }

    if (prevProps.getActivityStatus.isLoading && !this.props.getActivityStatus.isLoading) {
      const {
        creative,
        activity,
        getActivityStatus
      } = this.props;

      if (!creative && activity) {
        const {
          categoryId,
          typeId,
          background,
          tree
        } = activity;

        const mergedActivity = _.merge(this.defaultState.activity, activity);

        const updatedState = _.cloneDeep(this.defaultState);

        if (categoryId) {
          mergedActivity.category = categoryId;
        }

        if (background) {
          if (background.gradient && background.gradient.start && background.gradient.start.length > 0) {
            updatedState.backgroundType = 'gradient';
          } else if (background.filename && background.filename.length > 0) {
            updatedState.backgroundType = 'image';
          }
        }

        if (typeId === Type.cyoa && tree) {
          const {
            questions,
            options
          } = tree;
          const {
            firstId
          } = mergedActivity; // activity.tree.questions and activity.tree.options sent from api are JSON strings

          mergedActivity.firstId = firstId.toString();
          const iterableQuestions = [];
          const iterableOptions = [];
          const intakeQuestions = JSON.parse(questions);
          const intakeOptions = JSON.parse(options);

          function mapToTreeQuestion(id) {
            const question = intakeQuestions[id];
            return [id.toString(), { ...question,
              id: id.toString(),
              optionIds: question.optionIds.map(id => id.toString())
            }];
          }

          function mapToTreeOption(id) {
            var _a;

            const option = intakeOptions[id];
            return [id.toString(), { ...option,
              id: id.toString(),
              questionId: (_a = option.questionId) === null || _a === void 0 ? void 0 : _a.toString()
            }];
          }

          function buildQuestions(id) {
            if (id) {
              iterableQuestions.push(mapToTreeQuestion(id));
              intakeQuestions[id].optionIds.forEach(optionId => {
                buildOptions(optionId);
              });
            }
          }

          function buildOptions(id) {
            iterableOptions.push(mapToTreeOption(id));
            buildQuestions(intakeOptions[id].questionId);
          }

          buildQuestions(firstId);
          mergedActivity.tree = {
            questions: new Map(iterableQuestions),
            options: new Map(iterableOptions)
          };
        }

        this.setState({ ...updatedState,
          activity: mergedActivity,
          loading: getActivityStatus.isLoading
        });
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }

  render() {
    const {
      current,
      statuses,
      loading
    } = this.state;
    const {
      visible,
      activity
    } = this.props;
    const steps = this.renderSteps();
    const footerActions = this.renderActions(steps.length);
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      key: activity ? activity.id : 'activity-modal',
      title: this.renderTitle(),
      visible: visible,
      onCancel: this.handleCancel,
      destroyOnClose: true,
      footer: footerActions,
      width: "60%",
      style: {
        minWidth: '800px'
      }
    }, !loading ? /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form-container"
    }, /*#__PURE__*/_react.default.createElement(_steps.default, {
      current: current,
      status: statuses[current]
    }, steps.map(s => /*#__PURE__*/_react.default.createElement(Step, {
      key: s.title,
      title: s.title
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form-content"
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, steps[current].content)))) : /*#__PURE__*/_react.default.createElement(_spin.default, null));
  }

}

const mapStateToProps = state => {
  return {
    getActivityStatus: selectors.getActivityStatus(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    upsertActivity: activity => dispatch(_activities.upsertActivityAsync.request(activity)),
    publishActivity: id => dispatch(_activities.publishActivityAsync.request(id))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActivityFormContainer);

exports.default = _default;